import React from "react";

import { Input } from "~/components/input";
import { useScope } from "~/tools/impulse";

import type { WidgetRange } from "./form-state";

export interface WidgetRangeFieldProps {
	className?: string;
	default?: number;
	name: string;
	value: WidgetRange;
}

export const WidgetRangeField: React.FC<WidgetRangeFieldProps> = ({ className, default: defaults, name, value }) => {
	const scope = useScope();

	return (
		<Input
			className={className}
			name={name}
			onChange={(event) => value.setInput(event.target.value)}
			placeholder={defaults?.toString() ?? "Default"}
			type="number"
			value={value.getInput(scope)}
		/>
	);
};
